import { render } from "./HomeChooseCard.vue?vue&type=template&id=180f933c&scoped=true&ts=true"
import script from "./HomeChooseCard.vue?vue&type=script&lang=ts"
export * from "./HomeChooseCard.vue?vue&type=script&lang=ts"

import "./style/homeChooseCard.scss?vue&type=style&index=0&id=180f933c&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180f933c"]])

export default __exports__